var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftarrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 20,
    height: 20,
    rx: 2,
    transform: "rotate(-90 0 20)",
    fill: "#D1DBCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 10.5917L7.04992 7.64169C6.89378 7.48648 6.68257 7.39937 6.46242 7.39937C6.24226 7.39937 6.03105 7.48648 5.87492 7.64169C5.79681 7.71916 5.73481 7.81133 5.69251 7.91288C5.6502 8.01443 5.62842 8.12335 5.62842 8.23336C5.62842 8.34337 5.6502 8.45229 5.69251 8.55384C5.73481 8.65539 5.79681 8.74756 5.87492 8.82503L9.40825 12.3584C9.48572 12.4365 9.57789 12.4985 9.67944 12.5408C9.78098 12.5831 9.88991 12.6049 9.99992 12.6049C10.1099 12.6049 10.2188 12.5831 10.3204 12.5408C10.4219 12.4985 10.5141 12.4365 10.5916 12.3584L14.1666 8.82503C14.2438 8.74716 14.3049 8.65481 14.3464 8.55328C14.3879 8.45175 14.4089 8.34303 14.4082 8.23336C14.4089 8.12369 14.3879 8.01497 14.3464 7.91344C14.3049 7.81191 14.2438 7.71956 14.1666 7.64169C14.0104 7.48648 13.7992 7.39937 13.5791 7.39937C13.3589 7.39937 13.1477 7.48648 12.9916 7.64169L9.99992 10.5917Z",
    fill: "#2D5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow2);
export default __webpack_public_path__ + "static/media/left arrow2.2f0c378de2c363ad60a14e974f15f127.svg";
export { ForwardRef as ReactComponent };